import { apiSlice } from '../api/apiSlice';
import { setReminderNotification } from '../process/processSlice';
import { setMessageNotification, setPositionId } from './profileSlice';

export const profileApi = apiSlice.injectEndpoints({
	tagTypes: ['Profile'],
	endpoints: (builder) => ({
		GetIndividualData: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity-no-pic/self',
				method: 'POST',
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const response = await queryFulfilled;

					if (response?.data?.length === 1) {
						let id = response?.data?.[0].positionCode;

						dispatch(setPositionId(id));
					}
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		GetMessageCount: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/message/userid-count',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const response = await queryFulfilled;
					if (response.data.status === 'SUCCESS') {
						dispatch(
							setMessageNotification({
								unreadMessageCount: response?.data?.countTotal,
								unreadCompletedMessageCount: response?.data?.countComplete,
								unreadOpenMessageCount: response?.data?.countOpen,
							})
						);
					}
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		GetMessageNotification: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/message/get-by-user-id-paged',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => {
					return response.status === 200 && result?.status === 'SUCCESS';
				},
			}),
			// async onQueryStarted(arg, { queryFulfilled, dispatch }) {
			//   try {
			//     const response = await queryFulfilled;
			//     if (response.data.status === "SUCCESS") {
			//       dispatch(
			//         setMessageNotification({
			//           unreadMessageNotificationCount: response?.data?.unreadCount,
			//         })
			//       );
			//     }
			//   } catch (error) {}
			// },
		}),
		MarkReadMessageNotification: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/message/mark-read',
				method: 'POST',
				body: data,
			}),
			// async onQueryStarted(arg, { queryFulfilled, dispatch }) {
			//   try {
			//     const response = await queryFulfilled;
			//     if (response.data.status === "SUCCESS") {
			//       dispatch(
			//         setMessageNotification({
			//           unreadMessageNotificationCount: response?.data?.unreadCount,
			//         })
			//       );
			//     }
			//   } catch (error) {}
			// },
		}),
		MarkClickedMessageNotification: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/mark-workflow-instance-stage-message',
				method: 'POST',
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const response = await queryFulfilled;
					if (response.data.status === 'SUCCESS') {
						dispatch(
							setMessageNotification({
								unreadMessageCount: response?.data?.unreadCount,
								// messageNotificationList: response?.data?.allMessages,
								// unreadMessageNotificationList: response?.data?.unreadMessages,
							})
						);
					}
				} catch (error) {
					// console.log(error);
				}
			},
		}),
		GetSupervisionDetails: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/get-supervision-details',
				method: 'POST',
				body: data,
			}),
		}),
		GetCompanySupervisionDetails: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/get-company-supervision-details',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		GetReminderList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/reminder/get-by-user',
				method: 'POST',
				body: data,
			}),
		}),
	}),
});

export const {
	useGetIndividualDataMutation,
	useGetSupervisionDetailsMutation,
	useGetMessageNotificationMutation,
	useMarkReadMessageNotificationMutation,
	useGetCompanySupervisionDetailsMutation,
	useMarkClickedMessageNotificationMutation,
	useGetReminderListMutation,
	useGetMessageCountMutation,
} = profileApi;
